export default __webpack_public_path__ + "static/media/time.c78a223d.svg";